import { setIsFocusInSearchBox } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

// set search box focus by subscribing to setIsFocusInSearchBox
mutator(setIsFocusInSearchBox, actionMessage => {
    getStore().isFocusInSearchBox = actionMessage.isFocusInSearchBox;
});
